export const PAGE = 1;
export const PAGE_SIZE = 20;
export const DEFAULT_PAGINATION = {
  page: PAGE,
  pageSize: PAGE_SIZE,
  total: 0,
  lastPage: 0,
};
